import React from "react"
import { ref, onValue } from "firebase/database"

import { sdk9db } from "../firebase"
import { UserBalance } from "../types"
import { getStudentBalance } from "../utils/users"

export const useStudentMinutes = (userId?: string) => {
  /**
   * This hook is a wrapper around `users.ts`. It listens for collection
   * to change, and then fires the synchronous actions in `users.ts`.
   * This is a way to have one sec of code to compute the data we need,
   * while also getting a "realtime" view of that data.
   *
   * It's also a lead into what we'll need to do with the ledger,
   * since the ledger is on Mongo and won't have realtime capability
   * directly.
   */
  const [studentMinutes, setStudentMinutes] =
    React.useState<UserBalance | null>(null)

  React.useEffect(() => {
    if (!userId) return undefined

    const refreshFetch = () => {
      getStudentBalance(userId).then((data) => setStudentMinutes(data))
    }

    const unsub = onValue(
      ref(sdk9db, `studentBalanceSnapshotsHash/${userId}`),
      () => refreshFetch(),
    )

    return () => {
      unsub()
    }
  }, [userId])

  return studentMinutes
}
